var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHashtag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5d626c",
    d: "M35.411 14.312l.574-3.214a.964.964 0 0 0-.949-1.134h-6.012l1.176-6.58a.964.964 0 0 0-.95-1.134h-3.265a.964.964 0 0 0-.949.795L23.8 9.964h-7.926l1.175-6.581A.964.964 0 0 0 16.1 2.25h-3.266a.964.964 0 0 0-.949.795L10.65 9.964H4.294a.964.964 0 0 0-.949.795l-.575 3.214a.964.964 0 0 0 .949 1.134h6.012L7.894 25.393H1.539a.964.964 0 0 0-.949.795L.015 29.4a.964.964 0 0 0 .949 1.134h6.012L5.8 37.116a.964.964 0 0 0 .95 1.134h3.265a.964.964 0 0 0 .949-.795l1.236-6.919h7.926l-1.175 6.581a.964.964 0 0 0 .949 1.133h3.265a.964.964 0 0 0 .949-.795l1.236-6.919h6.356a.964.964 0 0 0 .949-.795l.574-3.214a.964.964 0 0 0-.949-1.134h-6.011l1.837-10.286h6.356a.964.964 0 0 0 .949-.795zM21.045 25.393h-7.926l1.837-10.286h7.926z",
    transform: "translate(0 -2.25)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHashtag);
export default __webpack_public_path__ + "static/media/hashtag.ad031c77b65355b1c5897b19a834f5a8.svg";
export { ForwardRef as ReactComponent };